import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AboutVCNR from "./pages/AboutVCNR";
import Lenis from "@studio-freight/lenis";
import Leadership from "./pages/Leadership";
import Career from "./pages/Career";
import Contact from "./pages/Contact";
import Healthcare from "./pages/Healthcare";
import Technologies from "./pages/Technologies";
import Builders from "./pages/Builders";
import AgroTech from "./pages/Agrotech";
import Foundation from "./pages/Foundation";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import Hospitality from "./pages/Hospitality";
import GoldDiamonds from "./pages/GoldDiamonds";
import { HelmetProvider } from "react-helmet-async"; // ✅ Imported
import NotFound from "./pages/NotFound";
import Educational from "./pages/educational";
import Properties from "./pages/Properties";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const AppLayout = () => {
  const [showLayout, setShowLayout] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis();
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  }, []);

  return (
    <>
       {showLayout && <Header />}
<AnimatePresence mode="wait">
  <motion.div
    key={location.pathname}
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.4, ease: "easeInOut" }}
  >
    <Routes location={location}>
      <Route path="/" element={<Home setShowLayout={setShowLayout} />} />
      <Route path="/aboutVCNR" element={<AboutVCNR />} />
      <Route path="/Leadership" element={<Leadership />} />
      <Route path="/Career" element={<Career />} />
      <Route path="/Contact" element={<Contact />} />
      <Route path="/Healthcare" element={<Healthcare />} />
      <Route path="/Technologies" element={<Technologies />} />
      <Route path="/Builders" element={<Builders />} />
      <Route path="/Agrotech" element={<AgroTech />} />
      <Route path="/Foundation" element={<Foundation />} />
      <Route path="/Goldandiamonds" element={<GoldDiamonds />} />
      <Route path="/Hospitality" element={<Hospitality />} />
      <Route path="/Privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/Termsandconditions" element={<TermsAndConditions />} />
      <Route path="/Educational" element={<Educational />} />
      <Route path="/Properties" element={<Properties />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </motion.div>
</AnimatePresence>

      {showLayout && <Footer />}
    </>
  );
};

const App = () => (
  <HelmetProvider> {/* ✅ Wrap your app here */}
    <Router>
      <AppLayout />
    </Router>
  </HelmetProvider>
);

export default App;
